<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" fab text :ripple="false" class="historic-button hidden-md-and-down">
        <v-icon>mdi-history</v-icon>
      </v-btn>
    </template>
    <v-sheet>
      <v-list class="pa-3">
        <v-list-item v-for="(history, i) in historicsChanges" :key="i" :class="i % 2 == 0 ? '' : 'grey lighten-3'">
          <v-list-item-content v-if="i === 0" >
            <span><v-chip small color="primary">{{ history.validator }} </v-chip> - {{ history.value }} </span>
          </v-list-item-content>
          <v-list-item-content v-else>
            <span>le {{ new Date(history.date).toLocaleDateString() }} par <v-chip small color="primary">{{ history.validator }} </v-chip> - {{ history.value }} </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-menu>
</template>

<script>
export default {
  name: "FieldHistory",
  props: ["historics","specificField"],
  mounted() {
    if (this.specificField) {
      this.processSpecificField();
    } else {
      this.historicsChanges = this.historics;
    }
  },
  data() {
    return {
      menu: false,
      historicsChanges: {}
    };
  },
  methods: {
    processSpecificField() {
      switch (this.specificField) {
        case 'supplier.email':
          this.historicsChanges = this.historics.map((history) => {
            let h = JSON.parse(JSON.stringify(history));
            h.value = h.value.email;
            return h
          });
          break;
        case 'supplier.name':
          this.historicsChanges = this.historics.map((history) => {
            let h = { ...history };
            h.value = h.value.name;
            return h
          });
          break;
        case 'supplier.address':
          this.historicsChanges = this.historics.map((history) => {
            let h = { ...history };
            h.value = h.value.address;
            return h;
          });
          break;
        case 'items':
          this.historicsChanges = this.historics.map((history) => {
            let h = { ...history };
            const items = h.value;
            const itemsFormatted = items.map((item) => {
              const textLength = 20;
              const description = item.description.length > textLength ? item.description.substring(0,20) + ' ...' : item.description;

              const qty = item.quantity ?? ''
              return `${qty} ${description}`
            }).join();
            h.value = itemsFormatted;
            return h;
          });
          break;
        default:
          return 'NaN';
      }
    }
  }
};
</script>

<style>
  .historic-button {
    position: absolute;
    right: 30px;
  }
</style>
